import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerPermCurrentDetailsRequest extends BaseUpdateRequest {
    currentAnnualSalary = 0;
    currentPositionId: string = null;
}